/** @format */

import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HomeDirectiveModule } from '@home/utils';
import { HtmlSanitizerPipe } from '@shared/utils/pipes';
import { KrakenComponent } from './kraken.component';
import { KrakenService } from './kraken.service';

@NgModule({
	imports: [CommonModule, HomeDirectiveModule, HtmlSanitizerPipe],
	declarations: [KrakenComponent],
	exports: [KrakenComponent],
	providers: [KrakenService],
	schemas: [NO_ERRORS_SCHEMA]
})
export class KrakenModule {}
